
const VG_TO_IMD_ICON = [
  'transit_instruction_go_down',
  'transit_instruction_go_up',
  'transit_instruction_straight',
  'transit_instruction_turn_gentle_left',
  'transit_instruction_turn_gentle_right',
  'transit_instruction_turn_left',
  'transit_instruction_turn_right',
  'transit_instruction_turn_sharp_left',
  'transit_instruction_uturn_left',
  'transit_instruction_uturn_right'
].reduce((acc, x) => {
  acc[`${x}.png`] = `vg_${x}`;
  return acc;
}, {});

function VGNavigationHelper (vgContext, navigation) {

  const { currentNavigation } = vgContext.state;
  const { floorMapping } = vgContext.options;
  const { route, instructions } = navigation;
  const firstLeg = route.legs[0];
  const [lastLeg] = route.legs.slice(-1);
  const startFloor = floorMapping[firstLeg.dataset].floor;
  const targetFloor = floorMapping[lastLeg.dataset].floor;


  const data = {
    showGuiding: true,
    imdFloorIndex: startFloor.order,
    imdFloorName: startFloor.name,
    targetFloorId: targetFloor.id,
    targetFloorIndex: targetFloor.order,
    targetFloorName: targetFloor.name,
    routes: instructions.map((inst, index) => ({
      id: index,
      detail: inst.detail,
      floor: inst.dataset,
      icon: VG_TO_IMD_ICON[inst.icon] || inst.icon
    }))
  };

  this.getRouteData = () => {
    const index = currentNavigation.currentIndex();
    const currentRoute = Object.assign({ active: true }, data.routes[index]);
    const routes = [
      ...data.routes.slice(0, index),
      currentRoute,
      ...data.routes.slice(index + 1)
    ];
    return Object.assign({}, data, { currentRoute, routes });
  };

  this.goToInstruction = null;

  this.getCurrentRoute = _ => data.routes[currentNavigation.currentIndex()];
  this.displayNextInstruction = _ => currentNavigation.displayNextInstruction();
  this.instructionsLeft = _ => currentNavigation.instructionsLeft();
  this.currentIndex = _ => currentNavigation.currentIndex();
}

module.exports = VGNavigationHelper;
